import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrganizationUnitDto, OrganizationUnitServiceProxy, UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-role-filter',
  templateUrl: './role-filter.component.html',
})
export class RoleFilterComponent implements OnInit {

    @Output() changeRoles = new EventEmitter<any[]>();
    @Input() inputRoleItems: any[];

    // Input properties
    @Input() multiselect: boolean;
    @Input() closeOnSelect: boolean;
    @Input() placeholder: string;

    // Non input properties
    bindLabel: string = "Roles";
    selectedItems: any[];
    isOpen: boolean;
    loading: boolean = false;
    showselectall: boolean = true;
    showdeselectall:boolean = false;

    constructor(private _userServiceProxy: UserServiceProxy,) {
    }

    ngOnInit(): void {
        this.selectedItems = this.inputRoleItems;
        this.loading = true;
        this.loading = false;
        this.getUserRoles();
    }


    userRoles:any[] = [];
    userRoleList:any[] = [];
    userRolesListSorted:any[] = [];
    async getUserRoles(){
        await this._userServiceProxy.getUserTenantRoles().subscribe(res=>{
            this.userRoles = res;
            this.userRoleList = [];
            this.userRoles.forEach(u=>{
                var v = {};
                v['id'] = u.roleId;
                v['Roles'] = u.roleName;

                if(u.roleName == 'Admin'){
                    v['description'] = 'They will get full access to IN TIME PROS account including clients, invoices and reports.';
                    v['icon'] = 'assets/common/images/invite-users-icons/adminiconupdate.svg';
                    v['iconcolored'] = 'assets/common/images/invite-users-icons/admincolored.svg';
                    v['class'] = 'text-info';
                    v['cumtomColor'] = 'mycss';
                }
                else if(u.roleName == 'Manager'){
                    v['description'] = ' They will get full access to IN TIME PROS account but can\'t see financial reports. ' ;
                    v['icon'] = 'assets/common/images/users/Managersicon.svg';
                    v['iconcolored'] = 'assets/common/images/users/Managersicon.svg' ;
                    v['class'] = 'text-warning';
                    v['cumtomColor'] = 'mycssyellow';
                }
                else if(u.roleName == 'Employee'){
                    v['description'] = 'They can track time for assigned projects, and can only see their own information.';
                    v['icon'] = 'assets/common/images/invite-users-icons/employeeiconupdate.svg';
                    v['iconcolored'] = 'assets/common/images/invite-users-icons/Employeecolored.svg';
                    v['class'] = 'cust-text-green';
                    v['cumtomColor'] = 'mycssgreen';
                }
                else if(u.roleName == 'Contractor'){
                    v['description'] = 'They can track time for assigned projects, and can send you invoices.';
                    v['icon'] = 'assets/common/images/invite-users-icons/contractoriconupdate.svg';
                    v['iconcolored'] = 'assets/common/images/invite-users-icons/Contractorcolored.svg';
                    v['class'] = 'cust-text-red';
                    v['cumtomColor'] = 'mycss';
                }
                else if(u.roleName == 'Program Manager'){
                    v['description'] = 'Program Manager gets access to view and create projects, timesheets, tasks, time tracking, reports, people';
                    v['icon'] = 'assets/common/images/invite-users-icons/programmanagericonupdate.svg';
                    v['iconcolored'] = 'assets/common/images/invite-users-icons/Programmanagercolored.svg';
                    v['class'] = 'cust-text-grey';
                    v['cumtomColor'] = 'mycss' ;
                }
                else if(u.roleName == 'Accountant'){
                    v['description'] = 'They can access invoices, reports and can create journal entries.';
                    v['icon'] = 'assets/common/images/invite-users-icons/accountanticonupdate.svg';
                    v['iconcolored'] = 'assets/common/images/invite-users-icons/Accountantcolored.svg';
                    v['class'] = 'cust-text-grey';
                    v['cumtomColor'] = 'mycss';
                }
                else if(u.roleName == 'Client'){
                    v['description'] = 'Client gets access to view and approve their own projects and their team members timesheets, tasks, invoices, payments related to assigned projects.';
                    v['icon'] = 'assets/common/images/invite-users-icons/clienticonupdate.svg';
                    v['iconcolored'] = 'assets/common/images/invite-users-icons/Clientcolored.svg';
                    v['class'] = 'cust-text-grey';
                    v['cumtomColor'] = 'mycss';
                }else{
                    return;
                }                

                this.userRoleList.push(v);      

            })

            this.userRolesListSorted = this.userRoleList.sort((u1,u2)=>{
                var orderDict = {'Admin':1,'Manager':2,'Employee':3,'Contractor':4,'Program Manager':5,'Accountant':6,'Client':7}

                var u1Order = orderDict[u1['Roles']];
                var u2Order = orderDict[u2['Roles']];

                return u1Order - u2Order;

            }
            )

        })
    }

    ngOnChanges() {
        this.selectedItems = this.inputRoleItems;
    }

    emitSelection() {
        if(this.selectedItems.length != this.userRolesListSorted.length){
        this.showselectall = true;
        this.showdeselectall = false;
        } else {
            this.showselectall = false;
            this.showdeselectall = true;
        }
        this.changeRoles.emit(this.selectedItems);
    }

    selectAll() {
        this.selectedItems = this.userRolesListSorted;
        this.showselectall=false;
        this.showdeselectall = true;
        this.changeRoles.emit(this.selectedItems);
    }

    unselectAll() {
        this.selectedItems = [];
        this.showselectall=true;
        this.showdeselectall = false;
        this.changeRoles.emit(this.selectedItems);
    }
    rearrangeItems() {
        if (this.multiselect && this.selectedItems && this.selectedItems.length > 0) {

        this.userRolesListSorted = [...this.userRolesListSorted.filter(r => this.selectedItems.includes(r)), ...this.userRolesListSorted.filter(r => !this.selectedItems.includes(r))]
        }
    }

    checkUncheck(item) {
        item.selected = !item.selected;
    }
}